<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M4 6h16M6.5 4.5v3M4 12h16m-8-1.5v3M4 18h16m-3.5-1.5v3"/>
</svg>
